<div class="reports-container">
    <div class="header">
    </div>
    <div class="content-wrapper">
      <!-- PowerBI Report Container -->
      <div #reportContainer id="reportContainer">
        <!-- Loading indicator -->
        <div *ngIf="isLoading" class="loading-container">
          <div class="spinner"></div>
          <p>Loading report...</p>
        </div>
        <!-- Error message -->
        <div *ngIf="hasError" class="error-message">
          <h3>Report Access Required</h3>
          <p>{{ errorMessage }}</p>
          <p>Please contact your administrator for access.</p>
        </div>
      </div>
    </div>
  </div>